import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createBlock as _createBlock, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"
import _imports_0 from '@/assets/img/icon/closed-deposit-outline-blue.svg'
import _imports_1 from '@/assets/img/icon/user-outline-black.svg'
import _imports_2 from '@/assets/img/icon/bus-outlined-black.svg'
import _imports_3 from '@/assets/img/icon/check-circle-green.svg'


const _hoisted_1 = { class: "mb-4 border-grey-3 rounded-lg p-4 background-grey-1" }
const _hoisted_2 = { class: "flex justify-between" }
const _hoisted_3 = { class: "flex items-center gap-2" }
const _hoisted_4 = { class: "text-2xl font-extrabold cursor-pointer" }
const _hoisted_5 = { class: "flex items-center gap-4 mb-2" }
const _hoisted_6 = { class: "flex items-center gap-3" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "closed-deposit"
}, null, -1)
const _hoisted_8 = { class: "text-lg font-bold cursor-pointer text-primary" }
const _hoisted_9 = {
  key: 0,
  class: "text-primary text-xs font-normal text-center border-primary py-1 px-2 rounded-md background-blue-4"
}
const _hoisted_10 = { class: "flex items-center gap-3" }
const _hoisted_11 = { class: "flex items-center gap-2" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("img", {
  class: "",
  src: _imports_1,
  style: {"min-width":"12px","height":"12px"},
  alt: ""
}, null, -1)
const _hoisted_13 = { class: "text-grey text-xs font-bold" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", null, "|", -1)
const _hoisted_15 = { class: "flex items-center gap-2" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  class: "w-4",
  alt: "bus"
}, null, -1)
const _hoisted_17 = { class: "text-grey text-xs font-bold" }
const _hoisted_18 = { class: "flex items-end" }
const _hoisted_19 = { class: "flex justify-end items-center gap-2" }
const _hoisted_20 = { class: "text-2xl text-green font-extrabold text-right" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  alt: "checked"
}, null, -1)
const _hoisted_22 = { class: "text-grey text-xs" }
const _hoisted_23 = { class: "mt-40px flex justify-end" }
const _hoisted_24 = { class: "flex items-center justify-end" }
const _hoisted_25 = /*#__PURE__*/_createTextVNode("Kembali")

import { encryptDecriptMethods } from '@/plugins/encryptDecriptMethods'
import { onMounted, ref, reactive } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useStore } from 'vuex'
import Card from 'primevue/card'
import Button from 'primevue/button'
import apiUseCase from '@/usecase/apiUseCase'
import Popper from 'vue3-popper'
import moment from 'moment'
import HjpConfirmationModal from '@/views/components/modal/HjpConfirmationModal.vue'
import currencyNumberFormat from '@/utils/helpers/rupiahFormat'
import HjpTabView from '@/views/components/tab/HjpTabView.vue'
import DetailTable from './list/detail/DetailTable.vue'
import SnackListDetail from './list/detail/SnackListDetail.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'Detail',
  setup(__props) {

const transactionPpsEndpoint = 'transaction/v2/TransactionPps'
const store = useStore()
const route = useRoute()
const router = useRouter()
const idPrams = ref()
const title = ref('')
const dataSource = ref()
const isLoading = ref(true)
const positionTabs = ref(0)

const tabHeader = ref([
  { title: 'SETORAN KARCIS', value: 0 },
  { title: 'SETORAN SNACK', value: 1 }
])

const tabsChange = (val: any) => {
  console.log('change')
  positionTabs.value = val
}

const backToMaster = () => {
  router.push({
    name: 'cashless-closed-deposits'
  })
}

onMounted(() => {
  idPrams.value = encryptDecriptMethods.decrypt(route.params.id)
  // console.log(idPrams.value.TrxId)
  title.value = idPrams.value.TrxId
  store.dispatch('ui/setBreadcrumbs', [
    {
      title: 'Closing Setoran Non-Tunai',
      routeName: 'cashless-closed-deposits'
    },
    {
      title: title.value,
      routeName: 'cashless-closed-deposits-detail'
    }
  ])
  // getDataDetail()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_unref(Card), { class: "card-no-shadow mb-4" }, {
      content: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, _toDisplayString(idPrams.value?.TrxId ?? '-'), 1)
              ]),
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _hoisted_7,
                  _createElementVNode("div", _hoisted_8, _toDisplayString(`${idPrams.value?.PrintCode}-${_unref(moment)(idPrams.value?.CreatedAt).format('DD MMMM YYYY HH:mm')}`), 1)
                ]),
                (idPrams.value?.HasNonCash)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_9, "Non Tunai"))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _hoisted_12,
                  _createElementVNode("div", _hoisted_13, _toDisplayString(`Kondektur: ${idPrams.value?.CondecturName ?? '-'}`), 1)
                ]),
                _hoisted_14,
                _createElementVNode("div", _hoisted_15, [
                  _hoisted_16,
                  _createElementVNode("div", _hoisted_17, _toDisplayString(`Nopol: ${idPrams.value?.VehicleRegNumber ?? '-'}`), 1)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("div", _hoisted_20, _toDisplayString(_unref(currencyNumberFormat)(idPrams.value?.TotalNonCashTicketAmount)), 1),
                  _hoisted_21
                ]),
                _createElementVNode("div", _hoisted_22, _toDisplayString(`Tanggal closing: ${idPrams.value?.CompletedAt ? _unref(moment)(idPrams.value?.CompletedAt).format('DD MMMM YYYY') : '-'}`), 1)
              ])
            ])
          ])
        ]),
        _createVNode(HjpTabView, {
          onTabsChange: tabsChange,
          tabHeader: tabHeader.value
        }, null, 8, ["tabHeader"]),
        (positionTabs.value === 0)
          ? (_openBlock(), _createBlock(DetailTable, {
              key: 0,
              transactionId: idPrams.value?.Id,
              transactionHeaderId: idPrams.value?.headerId
            }, null, 8, ["transactionId", "transactionHeaderId"]))
          : _createCommentVNode("", true),
        (positionTabs.value === 1)
          ? (_openBlock(), _createBlock(SnackListDetail, {
              key: 1,
              transactionId: idPrams.value?.Id
            }, null, 8, ["transactionId"]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_23, [
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_24, [
              _createVNode(_unref(Button), {
                class: "btn-back mr-2",
                onClick: backToMaster
              }, {
                default: _withCtx(() => [
                  _hoisted_25
                ]),
                _: 1
              })
            ])
          ])
        ])
      ]),
      _: 1
    })
  ]))
}
}

})